import { render, staticRenderFns } from "./DistroTable.vue?vue&type=template&id=5b2cb413"
import script from "./DistroTable.vue?vue&type=script&lang=js"
export * from "./DistroTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports